module.exports = __webpack_public_path__ + "img/1404.de41599c.gif";